import {
    QUERY_KEY_PAGINATION_SIMPLE_SINGLE_VOYAGES,
    QUERY_KEY_SINGLE_VOYAGE_BY_ID,
    QUERY_KEY_SINGLE_VOYAGES
} from "@containers/singleVoyage/fetchingData/queryHooks/constants/queryKey";
import {queryClient} from "@app/appProvider/queryClient/queryClient";

export const refetchSingleVoyages = () => {
    queryClient.invalidateQueries({queryKey: [QUERY_KEY_SINGLE_VOYAGES]});
    queryClient.invalidateQueries({queryKey: [QUERY_KEY_SINGLE_VOYAGE_BY_ID]});
    queryClient.invalidateQueries({queryKey: [QUERY_KEY_PAGINATION_SIMPLE_SINGLE_VOYAGES]});
}